import { ModelMixin } from '../core/base-generic.model';
import { InterviewQuestionType } from './interview-question-type.model';

export class InterviewQuestion extends ModelMixin<InterviewQuestion>() {
    protected static _resource = 'applicantTracker/interviewQuestions';
    protected static _version = 'v2';

    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];

    protected static _serializeAttributes = [
        'atsInterviewId',
        'atsInterviewQuestionId',
        'atsInterviewQuestionTypeId',
        'question',
        'isRequired',
        'questionIndex',
        'questionValues',
        'questionTypeMode',
    ];

    set id(val: number) {
        this._attributes['id'] = val;
    }

    get id(): number {
        return Number(this._attributes['id']) || null;
    }

    get atsInterviewId(): number {
        return this._attributes['atsInterviewId'];
    }

    set atsInterviewId(val: number) {
        this._attributes['atsInterviewId'] = val;
    }

    get atsInterviewQuestionId(): number {
        return this._attributes['atsInterviewQuestionId'];
    }

    get atsInterviewQuestionTypeId(): number {
        return this._attributes['atsInterviewQuestionTypeId'];
    }

    set atsInterviewQuestionTypeId(val: number) {
        this._attributes['atsInterviewQuestionTypeId'] = val;
    }

    get question(): string {
        return this._attributes['question'];
    }

    set question(val: string) {
        this._attributes['question'] = val;
    }

    get isRequired(): boolean {
        return this._attributes['isRequired'];
    }

    set isRequired(val: boolean) {
        this._attributes['isRequired'] = val;
    }

    get questionIndex(): number {
        return this._attributes['questionIndex'];
    }

    set questionIndex(val: number) {
        this._attributes['questionIndex'] = val;
    }

    get questionValues(): string[] | null {
        if (!this._attributes['questionValues']) {
            return null;
        }

        return JSON.parse(this._attributes['questionValues']);
    }

    set questionValues(val: string[] | null) {
        this._attributes['questionValues'] = val ? JSON.stringify(val) : null;
    }

    get questionTypeMode(): string {
        return this._attributes['questionTypeMode'];
    }

    set questionTypeMode(val: string) {
        this._attributes['questionTypeMode'] = val;
    }

    get interviewQuestionType(): InterviewQuestionType {
        return this.hasOne(InterviewQuestionType, 'interviewQuestionType');
    }

    set interviewQuestionType(val: InterviewQuestionType) {
        this.setOne('interviewQuestionType', val, 'atsInterviewQuestionTypeId');
    }

    get applicantInterviewFeedbackResults(): Array<unknown> {
        return this._attributes['applicantInterviewFeedbackResults'];
    }
}
